// src/lib/anim.ts - Versión Original Mejorada con Fluidez y Texto Visible
import { Variants } from "framer-motion";

// Curvas de easing cinematográficas personalizadas
const CINEMATIC_EASE_IN = [0.25, 0.1, 0.25, 1] as [
  number,
  number,
  number,
  number
];
const CINEMATIC_EASE_OUT = [0.16, 1, 0.3, 1] as [
  number,
  number,
  number,
  number
];

export const text: Variants = {
  initial: { opacity: 1, top: "40%" },
  enter: {
    opacity: 1, // Mantener visible más tiempo para páginas grandes
    top: "40%",
    transition: {
      duration: 1, // Más tiempo visible
      delay: 0.5, // Aparece después de que inicia la curva
      ease: [0.76, 0, 0.24, 1],
    },
  },
  exit: {
    opacity: 0, // Desaparece gradualmente
    top: "35%", // Sube ligeramente al desaparecer
    transition: {
      duration: 0.8,
      delay: 1.2, // Retraso mayor para que se vea más tiempo
      ease: [0.33, 1, 0.68, 1],
    },
  },
};

export const curve = (initialPath: string, targetPath: string): Variants => {
  return {
    initial: { d: initialPath, opacity: 1 },
    enter: {
      d: targetPath,
      opacity: 1,
      transition: { duration: 1.4, delay: 0.2, ease: [0.76, 0, 0.24, 1] }, // Ligeramente más lento
    },
    exit: {
      d: initialPath,
      opacity: 1,
      transition: { duration: 1.2, ease: [0.76, 0, 0.24, 1] }, // Más tiempo para salir
    },
  };
};

export const translate: Variants = {
  initial: { top: "-300px", opacity: 1 },
  enter: {
    top: "-100vh",
    opacity: 1,
    transition: { duration: 1.4, delay: 0.2, ease: [0.76, 0, 0.24, 1] }, // Sincronizado con curve
  },
  exit: {
    top: "-300px",
    opacity: 1,
    transition: { duration: 1.2, ease: [0.76, 0, 0.24, 1] }, // Más tiempo para salir
  },
};

// Nueva variante para el contenido de la página
export const pageContent: Variants = {
  initial: {
    opacity: 0,
    y: 60,
    scale: 0.95,
    filter: "blur(8px)",
  },
  enter: {
    opacity: 1,
    y: 0,
    scale: 1,
    filter: "blur(0px)",
    transition: {
      duration: 1.0,
      delay: 0.8,
      ease: CINEMATIC_EASE_OUT,
      opacity: { duration: 0.8, delay: 0.8 },
      y: { duration: 1.0, delay: 0.8 },
      scale: { duration: 1.2, delay: 0.7 },
      filter: { duration: 0.8, delay: 0.9 },
    },
  },
  exit: {
    opacity: 0,
    y: -30,
    scale: 1.05,
    filter: "blur(5px)",
    transition: {
      duration: 0.6,
      ease: CINEMATIC_EASE_IN,
      opacity: { duration: 0.4 },
      y: { duration: 0.6 },
      scale: { duration: 0.5 },
      filter: { duration: 0.4 },
    },
  },
};

// Variante para overlay de transición inmediata
export const immediateOverlay: Variants = {
  initial: {
    opacity: 1,
    scale: 1,
    zIndex: 10000,
  },
  enter: {
    opacity: 1,
    scale: 1,
    zIndex: 10000,
    transition: {
      duration: 0,
      delay: 0,
    },
  },
  exit: {
    opacity: 0,
    scale: 1,
    zIndex: 10000,
    transition: {
      duration: 0.3,
      delay: 1.2,
      ease: CINEMATIC_EASE_IN,
    },
  },
};

export const anim = (variants: Variants) => {
  return {
    variants,
    initial: "initial",
    animate: "enter",
    exit: "exit",
  };
};
